import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import moment from "moment-timezone";
import React from "react";
import DefaultFases from "../../constants/DefaultFases";
import { languages } from "../../constants/languages";
import MatchContainer from "../../containers/results/MatchContainer";
import RoundDateTimeContainer from "../../containers/results/RoundDateTimeContainer";
import { getGameResults } from "../../util/GetGameResults";
import NoResultsMessage from "./NoResultsMessage";

const Results = (props) => (
  <div style={{ marginTop: 5 }}>
    {!props.tournament.online &&
    Object.keys(props.matchesPerTime).length > 0 ? (
      Object.keys(props.matchesPerTime)
        .sort((a, b) => {
          // Custom sorting to start the day at 4am instead of midnight
          const getAdjustedTime = (timeStr) => {
            const time = moment(timeStr, "HH:mm");
            const hour = time.hour();
            // If time is between 00:00-03:59, treat it as next day (add 24 hours)
            if (hour < 4) {
              return time.add(1, "day").unix();
            }
            return time.unix();
          };
          return getAdjustedTime(a) - getAdjustedTime(b);
        })
        .map((startTime, i) => {
          let matches = props.matchesPerTime[startTime].sort((a, b) => {
            let fields = props.tournament.fields || {};
            let fieldA = fields[a.field] || {};
            let fieldB = fields[b.field] || {};
            if (fieldA.num > fieldB.num) {
              return 1;
            } else if (fieldA.num < fieldB.num) {
              return -1;
            } else {
              return a.field - b.field;
            }
          });

          let allMatchesPlayed = true;

          for (let m in matches) {
            let poule = props.poulesByKey[matches[m].poule] || {};
            let scoreType =
              poule.scoreType ||
              (poule.bracket
                ? (props.tournament.scoringTypesPerBracket || {})[
                    poule.bracket
                  ] || {}
                : false) ||
              ((props.tournament.scoringTypesPerDivisionPerPhase || {})[
                poule.division
              ] || {})[poule.fase] ||
              "default";
            let scoring =
              scoreType === "default"
                ? props.tournament
                : (props.tournament.scoringTypes || {})[scoreType] ||
                  props.tournament;

            let notFinished = false;
            const useSets = (scoring.useSets || "0") === "1";

            if (useSets) {
              let gameResults = getGameResults(scoring, matches[m].sets || {});
              notFinished = !gameResults.finished;
            } else {
              notFinished =
                matches[m].score1 === null || matches[m].score2 === null;
            }

            let hideMatch = false;
            if (poule["status" + matches[m].team1]) {
              hideMatch = true;
            }
            if (poule["status" + matches[m].team2]) {
              hideMatch = true;
            }

            let division = props.divisionsObject[poule.division] || {};
            let nextPhase = (division.fases || DefaultFases)[
              Object.keys(division.fases || DefaultFases)[poule.fase + 1]
            ];
            let phaseFinished = nextPhase && nextPhase.started;

            if (notFinished && !hideMatch && !phaseFinished) {
              allMatchesPlayed = false;
              break;
            }
            let markConflict = false;
            let lastId = "";
            let lastHistoryItem = null;
            Object.keys(matches[m].history || {})
              .sort((a, b) => a - b)
              .forEach((h) => {
                let historyItem = matches[m].history[h];
                if (
                  historyItem.as === "team" &&
                  historyItem.asId &&
                  lastId !== historyItem.asId
                ) {
                  if (lastId !== "") {
                    markConflict = true;
                  }
                  lastId = historyItem.asId;
                  if (
                    markConflict &&
                    lastHistoryItem &&
                    historyItem.score1 === lastHistoryItem.score1 &&
                    historyItem.score2 === lastHistoryItem.score2
                  ) {
                    markConflict = false;
                  }
                  lastHistoryItem = historyItem;
                }
                if (historyItem.as === "admin" && markConflict) {
                  markConflict = false;
                }
              });
            if (markConflict) {
              allMatchesPlayed = false;
              break;
            }
          }
          return (
            <ExpansionPanel key={i} defaultExpanded={!allMatchesPlayed}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 500, paddingLeft: 1 }}
                >
                  {startTime}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{ paddingBottom: 0, paddingTop: 0, overflowX: "auto" }}
              >
                <div className="ResultsTableContainer">
                  <table className="ResultsTable">
                    <tbody>
                      {matches.map((match) => {
                        return (
                          <MatchContainer
                            key={match.id}
                            match={match}
                            {...props}
                            startTime={startTime}
                          />
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })
    ) : props.tournament.online && props.showOnlineMatches ? (
      <div>
        {Object.keys(props.onlineRounds).map((roundKey) => {
          let matches = props.onlineRounds[roundKey];
          let matchesForRound = [];
          let allMatchesPlayed = true;
          for (let m in matches) {
            let match = matches[m];
            const poule = props.poulesByKey[match.poule] || {};
            let scoreType =
              poule.scoreType ||
              (poule.bracket
                ? (props.tournament.scoringTypesPerBracket || {})[
                    poule.bracket
                  ] || {}
                : false) ||
              ((props.tournament.scoringTypesPerDivisionPerPhase || {})[
                poule.division
              ] || {})[poule.fase] ||
              "default";
            let scoring =
              scoreType === "default"
                ? props.tournament
                : (props.tournament.scoringTypes || {})[scoreType] ||
                  props.tournament;
            const useSets = (scoring.useSets || "0") === "1";

            let hideMatch = false;
            if (poule["status" + match.team1]) {
              hideMatch = true;
            }
            if (poule["status" + match.team2]) {
              hideMatch = true;
            }
            if (!hideMatch) {
              let markConflict = false;
              let lastId = "";
              let lastHistoryItem = null;
              Object.keys(matches[m].history || {})
                .sort((a, b) => a - b)
                .forEach((h) => {
                  let historyItem = matches[m].history[h];
                  if (
                    historyItem.as === "team" &&
                    historyItem.asId &&
                    lastId !== historyItem.asId
                  ) {
                    if (lastId !== "") {
                      markConflict = true;
                    }
                    lastId = historyItem.asId;
                    if (
                      markConflict &&
                      lastHistoryItem &&
                      historyItem.score1 === lastHistoryItem.score1 &&
                      historyItem.score2 === lastHistoryItem.score2
                    ) {
                      markConflict = false;
                    }
                    lastHistoryItem = historyItem;
                  }
                  if (historyItem.as === "admin" && markConflict) {
                    markConflict = false;
                  }
                });
              let notFinished = false;
              if (useSets) {
                let gameResults = getGameResults(
                  scoring,
                  matches[m].sets || {}
                );
                notFinished = !gameResults.finished;
              } else {
                notFinished =
                  matches[m].score1 === null || matches[m].score2 === null;
              }

              let division = props.divisionsObject[poule.division] || {};
              let nextPhase = (division.fases || DefaultFases)[
                Object.keys(division.fases || DefaultFases)[poule.fase + 1]
              ];
              let phaseFinished = nextPhase && nextPhase.started;

              if (notFinished && !phaseFinished) {
                allMatchesPlayed = false;
              }
              matchesForRound.push(match);
            }
          }
          let roundTime =
            (props.tournament.roundTimes || {})[Number(roundKey)] || {};
          let time = roundTime["time"] || "";
          let day = roundTime["day"] || "0";
          let date =
            day === "0"
              ? props.tournament.date
              : (props.daysByKey[day] || {}).date || "";
          if (date) {
            date = moment
              .unix(date)
              .tz(props.tournament.timezone || "Europe/Amsterdam")
              .format(languages.results.dateFormatRound);
          }

          return (
            <ExpansionPanel key={roundKey} defaultExpanded={!allMatchesPlayed}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 500, paddingLeft: 1 }}
                >
                  {languages.schedule.round +
                    " " +
                    (Number(roundKey) + 1) +
                    (time ? ": " + time : "") +
                    (date && props.days.length > 0
                      ? (time ? ", " : ": ") + date
                      : "")}
                </Typography>
                <RoundDateTimeContainer
                  tournament={props.tournament}
                  roundNum={Number(roundKey) + 1}
                  days={props.days}
                  daysByKey={props.daysByKey}
                />
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{
                  paddingBottom: 0,
                  paddingTop: 0,
                  overflowX: "auto",
                }}
              >
                <div className="ResultsTableContainer">
                  <table className="ResultsTable">
                    <tbody>
                      {matchesForRound.map((match) => {
                        return (
                          <MatchContainer
                            key={match.id}
                            match={match}
                            {...props}
                            startTime=""
                            online={true}
                          />
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
      </div>
    ) : (
      <NoResultsMessage
        title={
          props.multipleDays
            ? props.multipleLocations
              ? languages.results.noResultsMessageTitleDayLocation
              : languages.results.noResultsMessageTitleDay
            : props.multipleLocations
            ? languages.results.noResultsMessageTitleLocation
            : languages.results.noResultsMessageTitle
        }
      />
    )}
  </div>
);

export default Results;
